
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Preweddingresortinnagpur() {



  const cardData =
  {
    keyword: ' Pre-Wedding Resort in Nagpur District in Forest',
    heading:  'Woodland Escape: Pre-Wedding Resort in Nagpur District in Forest ',
    headingDescription: 'Woodland Escape Resort is an ideal pre-wedding resort in Nagpur District in forest surroundings, offering a beautifully immersive natural setting for your special celebration. Nestled amid lush tree-lined lawns and tranquil forest fringes, the resort provides an enchanting backdrop perfect for pre-wedding photography, intimate gatherings, and stylish celebrations. With cozy cottages for you and your loved ones, open-air venues framed by greenery, and tailored arrangements for décor, catering and comfort, Woodland Escape Resort blends romance, nature and elegance in one seamless experience.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Pre-Wedding Resort in Nagpur District in Forest",
      "description": "Celebrate love amidst the serene forests of Nagpur District. This resort offers a perfect blend of natural beauty, privacy, and luxury, ideal for couples planning pre-wedding shoots or romantic getaways."
    },
    {
      "name": "Nagpur Forest Pre-Wedding Resort",
      "description": "Set in a lush forest, this resort provides picturesque backdrops for pre-wedding photography. Couples can enjoy private villas, scenic nature trails, and guided forest walks for stunning photo opportunities."
    },
    {
      "name": "Nagpur Romantic Jungle Resort",
      "description": "A perfect hideaway for couples, this jungle resort offers romantic settings, cozy accommodations, and outdoor activities like nature walks and riverside dinners, making pre-wedding shoots truly memorable."
    },
    {
      "name": "Nagpur Couple Pre-Wedding Shoot Resort",
      "description": "Designed for couples, this resort provides curated pre-wedding photography packages, scenic spots, flower gardens, forest trails, and luxurious accommodations to make every frame magical."
    },
    {
      "name": "Nagpur Private Pre-Wedding Forest Resort",
      "description": "This resort ensures complete privacy for couples seeking intimate pre-wedding shoots. It features secluded cabins, private garden areas, and personalized services tailored to photography needs."
    },
    {
      "name": "Nagpur Luxury Pre-Wedding Resort",
      "description": "Combining luxury with nature, this resort offers premium villas, gourmet dining, spa services, and scenic forest locations, perfect for high-end pre-wedding photoshoots and couple stays."
    },
    {
      "name": "Nagpur Eco-Friendly Pre-Wedding Resort",
      "description": "An eco-conscious resort that allows couples to celebrate sustainably. Enjoy forest views, eco-cottages, solar-powered amenities, and natural surroundings ideal for nature-themed pre-wedding shoots."
    },
    {
      "name": "Nagpur Riverside Pre-Wedding Resort",
      "description": "Located near tranquil rivers, this resort offers beautiful waterfront spots, scenic bridges, and riverside gardens, perfect for romantic pre-wedding photography sessions."
    },
    {
      "name": "Nagpur Hill Pre-Wedding Resort",
      "description": "Perched on gentle hills, this resort provides panoramic landscapes, sunrise and sunset views, and hilltop photo locations for memorable pre-wedding shoots."
    },
    {
      "name": "Nagpur Weekend Pre-Wedding Resort",
      "description": "Ideal for short getaways, this resort offers weekend packages that include pre-wedding shoot sessions, forest exploration, and cozy couple activities for a relaxed and romantic experience."
    },
    {
      "name": "Nagpur Booking Pre-Wedding Resort",
      "description": "Easily book your pre-wedding stay online with flexible packages, tailored shoot plans, and priority access to scenic locations within the resort for couples."
    },
    {
      "name": "Nagpur One Day Pre-Wedding Resort",
      "description": "Perfect for couples with limited time, this resort provides one-day pre-wedding shoot packages including guided photo locations, makeup and styling support, and exclusive forest access."
    },
    {
      "name": "Nagpur Scenic Pre-Wedding Resort",
      "description": "Experience breathtaking views for your pre-wedding shoot with panoramic forest vistas, natural gardens, waterfalls, and riverside spots, creating picture-perfect memories."
    },
    {
      "name": "Nagpur Nature Pre-Wedding Shoot Resort",
      "description": "This resort offers immersive nature experiences with trails, floral gardens, birdwatching spots, and forest backdrops, making it ideal for outdoor pre-wedding photography."
    },
    {
      "name": "Nagpur Photography Pre-Wedding Resort",
      "description": "Tailored for professional photographers and couples, this resort provides multiple scenic spots, lighting-friendly natural settings, and privacy for uninterrupted pre-wedding shoots."
    }
  ],
  "tableData": [
    ["- Pre-Wedding Resort in Nagpur District in Forest", "- Nagpur Forest Pre-Wedding Resort"],
    ["- Nagpur Romantic Jungle Resort", "- Nagpur Couple Pre-Wedding Shoot Resort"],
    ["- Nagpur Private Pre-Wedding Forest Resort", "- Nagpur Luxury Pre-Wedding Resort"],
    ["- Nagpur Eco-Friendly Pre-Wedding Resort", "- Nagpur Riverside Pre-Wedding Resort"],
    ["- Nagpur Hill Pre-Wedding Resort", "- Nagpur Weekend Pre-Wedding Resort"],
    ["- Nagpur Booking Pre-Wedding Resort", "- Nagpur One Day Pre-Wedding Resort"],
    ["- Nagpur Scenic Pre-Wedding Resort", "- Nagpur Nature Pre-Wedding Shoot Resort"],
    ["- Nagpur Photography Pre-Wedding Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Ideal Pre-Wedding Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a stunning forest backdrop in Nagpur District, perfect for pre-wedding celebrations. The serene environment, lush greenery, and natural charm make it an ideal location for intimate gatherings, photoshoots, and celebrations."
  },
  {
    "WhyChooseheading": "Scenic Forest Surroundings",
    "WhyChoosedescription": "Nestled amidst dense trees and tranquil landscapes, the resort provides a picturesque setting for pre-wedding functions. Guests can enjoy nature walks, open lawns, and shaded sit-outs that enhance the beauty of the occasion."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Accommodation",
    "WhyChoosedescription": "The resort features elegantly designed rooms and cottages with modern amenities, forest views, and comfortable spaces. Couples and guests can relax and enjoy a luxurious stay while celebrating special moments."
  },
  {
    "WhyChooseheading": "Perfect for Photoshoots and Events",
    "WhyChoosedescription": "With its natural beauty, Woodland Escape Resort offers countless scenic spots for pre-wedding photoshoots. Open lawns, ponds, and forested paths provide stunning backdrops for capturing memorable moments."
  },
  {
    "WhyChooseheading": "Exclusive Outdoor Activities",
    "WhyChoosedescription": "Couples and their guests can enjoy nature walks, cycling, bonfires, and pond-side relaxation. These activities enhance the pre-wedding experience and provide a mix of adventure, leisure, and bonding time."
  },
  {
    "WhyChooseheading": "Catering and Refreshments",
    "WhyChoosedescription": "The resort offers freshly prepared meals, snacks, and beverages tailored for group celebrations. Woodland Escape ensures that every pre-wedding gathering is accompanied by delicious and satisfying cuisine."
  },
  {
    "WhyChooseheading": "Convenient Location with Forest Privacy",
    "WhyChoosedescription": "Located in Nagpur District, the resort is easily accessible while maintaining a secluded, forested ambiance. Couples can enjoy privacy, serenity, and natural beauty for a memorable pre-wedding experience."
  }
]


































  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a pre‑wedding resort in Nagpur district in forest?",
    answer: "Woodland Escape Resort offers a beautiful, forest‑surrounded setting in Nagpur district—perfect for pre‑wedding ceremonies, photoshoots and small gatherings where nature becomes your backdrop."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within comfortable driving distance from Nagpur city, making it convenient for couples and families to reach while enjoying the tranquillity of a forest‑setting."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for pre‑wedding events in the forest?",
    answer: "The resort provides scenic outdoor lawns surrounded by tree cover, elegant event spaces, dedicated zones for photoshoots amidst nature, customised décor in natural settings and comfortable guest accommodation."
  },
  {
    question: "Is Woodland Escape Resort suitable for family & friends attending pre‑wedding functions in a forest environment?",
    answer: "Yes! The resort is group‑friendly and family‑friendly—offering safe, comfortable, and picturesque surroundings for pre‑wedding events where everyone can relax, celebrate and enjoy nature together."
  },
  {
    question: "Does the resort provide catering and décor services for pre‑wedding events in the forest setting?",
    answer: "Absolutely. Woodland Escape Resort offers full catering—snacks, meals, beverages—and supports event décor, lighting and natural‑theme arrangements to make your pre‑wedding function seamless and memorable."
  },
  {
    question: "How can we book Woodland Escape Resort for a pre‑wedding event in Nagpur district’s forest setting?",
    answer: "You can contact the resort via phone or WhatsApp with your event details, or visit the official website to check availability. Booking in advance is recommended to secure the date, event space and forest‑view surroundings."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Sharma, Nagpur",
    text: "We held our pre‑wedding function at Woodland Escape Resort and it was magical! The forest surroundings, open‑air décor space and comfortable stay made it truly special. Highly recommended."
  },
  {
    name: "Ms. Anjali & Mr. Rohit, Nagpur",
    text: "Choosing Woodland Escape Resort for our pre‑wedding shoot was a great decision. The natural backdrop, friendly staff and seamless event arrangements made it an unforgettable experience."
  }
];

































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const preWeddingResortSchema = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "name": "Pre-Wedding Resort in Nagpur District in Forest",
  "image": "https://woodlandescape.com/assets/images/nagpur-prewedding-forest-resort.jpg",
  "description": "Celebrate love in a serene forest setting at our Pre-Wedding Resort in Nagpur District. Perfect for romantic shoots, couple getaways, and outdoor pre-wedding experiences amidst nature.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Nagpur",
    "addressRegion": "Maharashtra",
    "addressCountry": "IN"
  },
  "telephone": "+91-XXXXXXXXXX",
  "url": "https://woodlandescape.com/nagpur-pre-wedding-forest-resort",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "29",
    "bestRating": "5",
    "worstRating": "1"
  },
  "amenityFeature": [
    {"@type": "LocationFeatureSpecification", "name": "Romantic Forest Setting", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Couple Friendly", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Pre-Wedding Shoot Location", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Outdoor & Scenic Spots", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Luxury & Eco-Friendly Stay", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Riverside & Hill Views", "value": true}
  ]
};


  return (
    <div>
<Helmet>
  <title>Pre-Wedding Resort in Nagpur District in Forest | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your perfect pre-wedding shoot at our forest resort in Nagpur District. Enjoy scenic nature, luxury amenities, riverside views, and romantic settings for couples." 
  />
  <meta 
    name="keywords" 
    content="Pre-Wedding Resort in Nagpur District in Forest, Nagpur Forest Pre-Wedding Resort, Nagpur Romantic Jungle Resort, Nagpur Couple Pre-Wedding Shoot Resort, Nagpur Private Pre-Wedding Forest Resort, Nagpur Luxury Pre-Wedding Resort, Nagpur Eco-Friendly Pre-Wedding Resort, Nagpur Riverside Pre-Wedding Resort, Nagpur Hill Pre-Wedding Resort, Nagpur Weekend Pre-Wedding Resort, Nagpur Booking Pre-Wedding Resort, Nagpur One Day Pre-Wedding Resort, Nagpur Scenic Pre-Wedding Resort, Nagpur Nature Pre-Wedding Shoot Resort, Nagpur Photography Pre-Wedding Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(preWeddingResortSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/58.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Preweddingresortinnagpur;